export { default } from "./TranslateDrawerBody";
